import Forms from './../../utils/forms/forms';
import { mapGetters } from 'vuex';
import businessHourExceptionService from './../../services/businessHourException';
import businessHourExceptionTransformer from './../../transformers/businessHourException';
import moment from 'moment';

export default {
  data() {
    return {
      form: new Forms({
        date: {
          value: [],
          type: 'dateRange',
        },
        start: {
          value: '',
          type: 'time',
        },
        end: {
          value: '',
          type: 'time',
        },
        message: {
          value: '',
          type: 'text',
        },
      }),
    };
  },

  computed: {
    ...mapGetters({
      hours: 'businessHourExceptions',
    }),

    exceptionList() {
      return this.hours.map(o => Object.assign({}, o, {
        date: `${moment(o.start).format('DD-MM-YYYY')} - ${moment(o.end).format('DD-MM-YYYY')}`,
        start: moment(o.start).format('HH:mm'),
        end: moment(o.end).format('HH:mm'),
      }));
    },
  },

  mounted() {
    businessHourExceptionService.all();
  },

  methods: {
    /**
     * Handles form change event.
     *
     * @param {String} name Input name.
     * @param {String} value Input value.
     */
    onFormChange(name, value) {
      this.form.clearSuccess(name, value);
      this.form.clearErrors(name);
      this.form[name] = value;
      this.$forceUpdate();
    },

    /**
     * Confirm and saves the exception. If there is a appointment between the chosen time,
     * there will be a confirmation to ask the user what action does he want to take.
     */
    save() {
      /**
       * Reset the form in case of success.
       */
      const onSuccess = ({ data }) => {
        this.form.loading = false;
        this.$message({
          showClose: true,
          message: data.success.message,
          type: 'success',
        });
        this.showForm = false;
      };

      /**
       * Shows notification in case of validation error.
       *
       * @param {Object} errors The response error object.
       */
      const onError = (errors) => {
        this.form.loading = false;
        this.form.recordErrors(businessHourExceptionTransformer.fetch(errors));
        const errorsKeys = Object.keys(this.form.errors.errors);
        this.$message({
          showClose: true,
          message: errors[errorsKeys[0]][0],
          type: 'error',
        });
      };

      /**
       * Prepare the form data to match the api required fields.
       *
       * @param {Object} data The form data fields.
       * @param {Boolean} confirmed Confirmed field.
       */
      const prepareData = (data, confirmed = undefined) => {
        const startDate = moment(data.date[0]).format('YYYY-MM-DD');
        const endDate = moment(data.date[1]).format('YYYY-MM-DD');
        const result = {
          start: `${startDate} ${data.start}`,
          end: `${endDate} ${data.end}`,
          message: data.message,
        };
        result.confirmed = confirmed;
        return result;
      };
      const data = this.form.data();
      this.form.loading = true;
      return businessHourExceptionService.store(prepareData(data))
      .then(onSuccess)
      .catch((errors) => {
        if (errors.error && errors.error.code === 42201) {
          this.$confirm(errors.error.message, this.$t('messages.warning'), {
            confirmButtonText: this.$t('static.businessHours.exceptionalHoursSaveKeep'),
            cancelButtonText: this.$t('static.businessHours.exceptionalHoursSaveCancel'),
            type: 'warning',
          }).then(() => {
            businessHourExceptionService.store(prepareData(data, 1))
            .then(onSuccess).catch(onError);
          }).catch(() => {
            businessHourExceptionService.store(prepareData(data, 0))
            .then(onSuccess).catch(onError);
          });
          return;
        }
        onError(errors);
        return;
      });
    },

    /**
     * Deletes the exception for the given id.
     *
     * @param {Number} id
     */
    destroy(id) {
      this.destroyLoading = true;
      businessHourExceptionService.destroy(id)
      .then(() => {
        this.destroyLoading = false;
      }).catch(() => {
        this.destroyLoading = false;
      });
    },
  },

  components: {
    VFormTable: require('./../formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/exceptionalHours/exceptionalHours.js